<template>
  <div style="position: relative">
    <div ref="msgList" id="msgList" class="msgList bubbleList" :class="{ active: aiState === 3 }">
      <p v-for="(item, index) in message" :key="index" :class="userClass(item, userName)">
        <!-- 客服转接提示 -->
        <template v-if="item.type === 'notify'">
          <span class="system-message"> {{ item.message }}</span>
        </template>

        <!-- 发问引导的列表 -->
        <template v-else-if="item.type === 'askGuide'">
          <span class="questioning">
            <ul class="list">
              <li v-for="(item, index) in JSON.parse(item.message)" :key="index" @click="ConfirmBoot(item)">
                <span>{{ item.button_name }}</span>
              </li>
            </ul>
          </span>
        </template>

        <!-- 文本消息 -->
        <template v-else>
          <span v-if="headImg != ''" class="usernames">
            <img :src="headImg" />
          </span>
          <span v-else class="username"></span>

          <span v-if="item.type === 'talk'" class="tm">

            <div class="quote" v-if="item.replyTo != 0">
              <p class="name" :title="item.replyTo">{{ findQuoteName(item.replyTo) }}</p>
              <div v-html="findQuoteContent(item.replyTo)"></div>
            </div>

            <div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
            <div v-html="processLinks(item.message)"></div>
          </span>

          <span v-else-if="item.type === 'image'" class="tm">
            <div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
            <img :src="baseUrl + item.message.split('|')[0]" :alt="item.message.split('|')[1]" @click="viewImage" />
          </span>

          <span v-else-if="item.type === 'file'" class="tm">
            <div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
            <a :href="baseUrl + item.message.split('|')[0]" target="_blank">
              {{ item.message.split('|')[1] }}
            </a>
          </span>

          <span v-else-if="item.type === 'audio'" class="tm">
            <div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
            <audio controls="controls">
              <source :src="baseUrl + item.message.split('|')[0]" type="audio/aac" />
            </audio>
          </span>

          <span v-else-if="item.type === 'video'" class="tm">
            <div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
            <video controls>
              <source :src="baseUrl + item.message.split('|')[0]" type="video/mp4" />
            </video>
          </span>

          <span v-else-if="item.type === 'contact'" class="tm">
            <div class="form-preview">
              <div>
                {{
                  item.lanMessage
                    ? JSON.parse(item.lanMessage).formPrompt
                    : JSON.parse(item.message).formPrompt
                }}
              </div>
              <div>
                <!-- 使用 lanMessage 来渲染表单 -->
                <div v-for="(field, fieldIndex) in item.lanMessage
                  ? JSON.parse(item.lanMessage).messageSettings
                  : JSON.parse(item.message).messageSettings" :key="fieldIndex" class="form-preview-item">
                  <div v-if="field.isRequired !== 0">
                    <label>
                      {{ field.formFields }}
                      <em v-if="field.isRequired === 2">*</em>
                    </label>
                    <div class="el-input">
                      <textarea v-if="field.formFields === 'message'" :value="getFieldValue(
                        item.msgId,
                        getOriginalFieldName(item, field.formFields)
                      )
                        " @input="
                          updateFieldValue(
                            item.msgId,
                            getOriginalFieldName(item, field.formFields),
                            $event.target.value
                          )
                          " :required="field.isRequired === 2" :placeholder="field.prompt" autocomplete="off"
                        :readonly="!isLatestContact(item)" @blur="
                          validateField($event, field.regex, field.displayName)
                          "></textarea>
                      <input v-else :value="getFieldValue(
                        item.msgId,
                        getOriginalFieldName(item, field.formFields)
                      )
                        " @input="
                          updateFieldValue(
                            item.msgId,
                            getOriginalFieldName(item, field.formFields),
                            $event.target.value
                          )
                          " type="text" :required="field.isRequired === 2" :placeholder="field.prompt" autocomplete="off"
                        :readonly="!isLatestContact(item)" @blur="
                          validateField($event, field.regex, field.displayName)
                          " />
                    </div>
                  </div>
                </div>
                <!-- 提交部分保持不变 -->
                <div class="form-preview-item" v-if="isLatestContact(item)">
                  <button class="submit-button" type="button" @click="submitForm(item)">
                    Submit
                  </button>
                  <p class="form-preview-tip">{{ errorMessage }}</p>
                </div>
              </div>
            </div>
          </span>

          <!-- 显示成功返回的表单样式 -->
          <span v-else-if="item.type === 'contactR'" class="tm contactr">
            <div class="form-preview">
              <div>
                <div v-for="(field, fieldIndex) in item.lanMessage
                  ? JSON.parse(item.lanMessage).messageSettings
                  : JSON.parse(item.message).messageSettings" :key="fieldIndex" class="form-preview-item">
                  <div v-if="field.isRequired !== 0">
                    <label>
                      {{ field.formFields }}
                      <em v-if="field.isRequired === 2">*</em>
                    </label>
                    <div class="el-input">
                      <textarea v-if="field.formFields === 'message'" v-model="field.value" type="text"
                        :placeholder="field.value" autocomplete="off" readonly="readonly"></textarea>
                      <input v-else v-model="field.value" type="text" :placeholder="field.value" autocomplete="off"
                        readonly="readonly" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="contactr-hint">The form was submitted successfully!</p>
          </span>

          <span v-else class="tm">
            <div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
            {{ item.message }}
          </span>
          <span class="ts">
            {{ item.dateTime | dateFormat }}
            <em title="引用" class="yinyong" @click="Quote(item, userName)"></em>
          </span>

        </template>
      </p>

      <!-- 引用 -->
      <div class="quote-container" v-if="isQuoteShow && quoteContent != '' && !isCloseQuote">
        <div class="quote-container-name">{{ quoteUser }}:</div>
        <div class="quote-container-content" :title="quoteContent">{{ quoteContent }}</div>
        <em class="el-icon-circle-close close" @click="closeQuote">+</em>
      </div>
    </div>
    <div class="humanservice-wrap" ref="HumanSupport">
      <span v-if="isLostConn" class="offtip">You are offline</span>
    </div>

    <div class="jljw_IM_success_conact" :class="{jljw_IM_success:Bidding}" v-if="Bidding">
      <i></i>
    </div>

  </div>
</template>

<script>
import EventBus from '@/utils/EventBus'
export default {
  name: 'MessageContent',
  props: {
    message: {
      type: Array,
      default: () => [],
    },
    userName: {
      type: String,
      default: '',
    },
    headImg: {
      type: String,
      default: '',
    },
    serviceName: {
      type: String,
      default: '',
    },
    aiState: {
      type: Number,
      default: 0,
    },
    isLostConn: {
      type: Boolean,
      default: false,
    },
    isCloseQuote: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseUrl: this.$baseURL,
      errorMessage:
        'Please fill in at least one of these fields before submitting!',
      formInputs: {},
      formsuccess: false,

      // 引用回复
      isQuoteShow: false,
      quoteUser: "", // 被引用人
      quoteContent: "", //引用内容
      replyToId: 0, // 引用的msgID

      // 引导发问
      questioning: [],
      Bidding: false,
    }
  },
  computed: {
    latestContactEntry() {
      for (let i = this.message.length - 1; i >= 0; i--) {
        if (['contact', 'contactR'].includes(this.message[i].type)) {
          return this.message[i]
        }
      }
      return null
    },
  },
  methods: {
    findQuoteName(replyToId) {
      const quotedMessage = this.message.find(msg => msg.msgId === replyToId);
      if (quotedMessage) {
        // console.log(quotedMessage);
        // 如果room和user.name一样，是访客的消息，不展示引用人，因为访客没有名称
        if (quotedMessage.room == quotedMessage.user.name) {
          return "";
        } else {
          return quotedMessage.user.nickName + ":";
        }
      }
    },
    //  在列表中展示引用信息
    findQuoteContent(replyToId) {
      // 在message中查找msgId等于replyToId的消息
      const quotedMessage = this.message.find(msg => msg.msgId === replyToId);
      return quotedMessage ? quotedMessage.message : '[原消息已被撤回]';
    },
    // 过滤HTML标签的函数
    stripHtmlTags(html) {
      return html.replace(/<[^>]*>/g, '');
    },
    // 点击引用按钮
    Quote(msg) {
      this.quoteContent = this.stripHtmlTags(msg.message);
      this.isQuoteShow = true;
      this.isCloseQuote = false;
      this.replyToId = msg.msgId; // 引用的msgID
      EventBus.$emit('replyToId', this.replyToId)
      if (!msg.user || msg.user.name != this.userName) {
        // 客服
        this.quoteUser = this.serviceName;
      } else {
        // 访客
        this.quoteUser = "Me";
        // this.quoteUser = JSON.parse(localStorage.getItem("UserInfo")).realname;
      }
    },
    closeQuote() {
      this.replyToId = 0;
      EventBus.$emit('replyToId', this.replyToId)
      this.isQuoteShow = false;
      this.isCloseQuote = true;
      this.quoteContent = "";
    },
    processLinks(html) {
      if (!html) return '';

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const links = tempDiv.querySelectorAll('a');
      links.forEach(link => {
        if (!link.getAttribute('target')) {
          link.setAttribute('target', '_blank');
        }
      });

      return tempDiv.innerHTML;
    },
    isLatestContact(item) {
      const lastEntry = this.latestContactEntry
      return lastEntry && lastEntry.type === 'contact' && lastEntry === item
    },
    getFieldValue(msgId, field) {
      if (!this.formInputs[msgId]) {
        this.$set(this.formInputs, msgId, {})
      }
      return this.formInputs[msgId][field] || ''
    },
    updateFieldValue(msgId, field, value) {
      if (!this.formInputs[msgId]) {
        this.$set(this.formInputs, msgId, {})
      }
      this.$set(this.formInputs[msgId], field, value)
    },
    viewImage(e) {
      let src = e.target.src
      this.$emit('preview', src)
    },
    userClass(msg, userName) {
      let className = 'sys'
      if (msg.user === undefined) {
        className = 'other'
      } else if (msg.user.name === userName) {
        className = 'self'
      } else if (msg.type === "contactR") {
        className = 'self'
      } else {
        className = 'other'
      }
      if (msg.sendFail) {
        className = 'self'
      }
      return className
    },
    humanservice() {
      this.$emit('switchAi')
    },
    validateField(event, regex, label) {
      if (regex) {
        const re = new RegExp(regex)
        if (!re.test(event.target.value)) {
          this.errorMessage = `Invalid input for ${label}`
        } else {
          this.errorMessage = ''
        }
      }
    },
    // 新增方法：获取原始字段名称
    getOriginalFieldName(item, translatedField) {
      // 如果没有翻译数据，直接返回当前字段名
      if (!item.lanMessage) {
        return translatedField
      }

      const originalForm = JSON.parse(item.message)
      const translatedForm = JSON.parse(item.lanMessage)

      // 找到翻译后字段对应的原始字段
      const translatedSetting = translatedForm.messageSettings.find(
        (setting) => setting.formFields === translatedField
      )
      if (!translatedSetting) {
        return translatedField
      }

      // 通过索引匹配找到原始字段
      const index = translatedForm.messageSettings.indexOf(translatedSetting)
      return originalForm.messageSettings[index]?.formFields || translatedField
    },

    // 提交表单方法
    submitForm(item) {
      const originalForm = JSON.parse(item.message)
      let isValid = true
      const formData = this.formInputs[item.msgId]

      // 使用 lanMessage 进行验证
      const translatedForm = item.lanMessage
        ? JSON.parse(item.lanMessage)
        : originalForm

      // 检查是否至少有一个输入框填写了内容
      let hasAnyInput = false

      translatedForm.messageSettings.forEach((field, index) => {
        const originalField = originalForm.messageSettings[index]
        const value = formData[originalField.formFields]

        // 如果有任何一个字段有值，则标记为有输入
        if (value && value.trim() !== '') {
          hasAnyInput = true
        }

        if (field.isRequired !== 0) {
          if (field.regex && value) {
            const re = new RegExp(field.regex, 'u')
            if (!re.test(value)) {
              this.errorMessage = `Invalid input for ${field.displayName}`
              isValid = false
            }
          }
          if (field.isRequired === 2 && !value) {
            this.errorMessage = `${field.displayName} is required`
            isValid = false
          }
        }
      })

      // 如果没有任何输入，设置错误信息并阻止提交
      if (!hasAnyInput) {
        this.errorMessage = 'Please fill in at least one piece of information.'
        isValid = false
      }

      if (!isValid) {
        return
      }

      // 使用原始 message 数据构建提交数据
      originalForm.messageSettings.forEach((field) => {
        field.value = formData[field.formFields]
      })

      let messageContent = {}
      originalForm.messageSettings.forEach((field) => {
        messageContent[field.displayName] = formData[field.formFields]
      })

      originalForm.sendMsgId = item.msgId
      const params = {
        room: this.userName,
        message: messageContent,
        formValue: originalForm,
      }

      this.$emit('talk', params, 'saveFormMsg')
      this.formsuccess = true

      // 重置表单输入
      this.$set(this.formInputs, item.msgId, {})

      this.Bidding = true;
      setTimeout(() => {
        this.Bidding = false;
      }, 2000);

      // 提交成功后，模拟打开thanks然后关闭，以触发谷歌广告统计
      // let thanksIframe = document.createElement('iframe')
      // thanksIframe.src = '/thanks'
      // thanksIframe.style.display = 'none'
      // thanksIframe.onload = function () {
      //   document.body.removeChild(thanksIframe)
      // }
      // document.body.appendChild(thanksIframe);

    },
    scrollMessage() {
      setTimeout(() => {
        let box = document.getElementById('msgList')
        if (box) {
          box.scrollTop = box.scrollHeight
        }
      }, 200)
    },

    // 引导发问
    ConfirmBoot(item) {
      // 通过事件总线传递到 sendbox 的输入框中
      EventBus.$emit('updateTextarea', item.question);
    }
  },
  watch: {
    message() {
      let that = this;

      // 过滤数组，只保留type为"contactR"或"contact"的项
      const array = that.message.filter(item => item.type === "contactR" || item.type === "contact");
      // console.log(array)
      if (array.length > 0 && array[array.length - 1].type === "contact") {
        // 这里添加你想要触发的事件
        const event = JSON.parse((array[array.length - 1]).message).messageSettings
        // console.log(event)
        const hasRequiredValueTwo = event.some(item => item.isRequired === 2);

        // 有任意一个项的isRequired为2，屏蔽输入框
        if(hasRequiredValueTwo) {
          document.getElementById('jljw_IM_GdImBox').classList.add('forminput');
        }else{
          document.getElementById('jljw_IM_GdImBox').classList.remove('forminput');
        }
      } else {
        document.getElementById('jljw_IM_GdImBox').classList.remove('forminput');
      }

      setTimeout(() => {
        let box = that.$refs.msgList
        box.scrollTop = box.scrollHeight
      }, 200)
    },
    isCloseQuote(newVal, oldVal) {
      if (newVal) {
        this.closeQuote();
      }

    }
  },
  created() {
    this.scrollMessage()
    // console.log("message111", this.message);
  },
}
</script>
